const FormGroup = ({ children }) => {
  return (
    <div className="form-group">
      {children}
    </div>
  );
};

export default FormGroup;
